import React from "react";
import "../styles/Maintenance.scss";

interface MaintenanceProps {
    message?: string;
}

export default function Maintenance({ message }: MaintenanceProps) {
    return (
        <div className="maintenance-page">
            <div className="maintenance-container">
                <div className="maintenance-icon">🔧</div>
                <h1 className="maintenance-title">Технические работы</h1>
                <p className="maintenance-message">
                    {message || "Сервис временно недоступен. Мы проводим плановое обслуживание системы."}
                </p>
                <p className="maintenance-subtitle">
                    Пожалуйста, зайдите позже. Приносим извинения за неудобства.
                </p>
                <div className="maintenance-animation">
                    <div className="spinner"></div>
                </div>
            </div>
        </div>
    );
}
